/**
 * StatusBadge — pill-style status indicator with dot.
 * Props:
 *   status {string} — 'open' | 'inprogress' | 'waiting_for_customer' | 'closed'
 *   size   {string} — 'sm' | 'default'
 */

import { h } from 'preact'
import { t } from './support-i18n.js'

const STATUS_KEYS = {
  open:                 'support.inbox.status_open',
  inprogress:           'support.inbox.status_inprogress',
  waiting_for_customer: 'support.inbox.status_waiting',
  closed:               'support.inbox.status_closed',
}

export function statusLabel(status) {
  const key = STATUS_KEYS[status]
  if (key) return t(key)
  return status || t('support.inbox.status_unknown')
}

/** @deprecated Prefer statusLabel(status) */
export const STATUS_LABELS = new Proxy({}, {
  get(_target, prop) {
    if (typeof prop !== 'string') return undefined
    return statusLabel(prop)
  },
})

// Returns the CSS modifier suffix matching status-select-btn class names
export function statusCssKey(status) {
  return status || 'open'
}

export function StatusBadge({ status, size = 'default' }) {
  const label = statusLabel(status)
  const key   = statusCssKey(status)

  return (
    <span class={`status-select-btn status-${key}${size === 'sm' ? ' status-sm' : ''}`}>
      <span class={`status-dot status-dot-${key}`} />
      {label}
    </span>
  )
}
